const B2BHero = () => {
  return (
    <div className="relative w-full h-[720px] md:h-screen overflow-hidden font-fira-sans">
      <img
        src="/b2b/b2bhero.webp"
        alt=""
        aria-hidden="true"
        loading="eager"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />

      <div
        className="relative z-10 flex flex-col items-center justify-center text-center h-full w-[90%] md:w-auto mx-auto md:mx-[153px]"
        style={{
          borderLeft: "1px solid rgba(255, 255, 255, 0.20)",
          borderRight: "1px solid rgba(255, 255, 255, 0.20)",
        }}
      >
        <div className="max-w-3xl px-4 md:px-[60px]">
          <h1 className="text-[32px] md:text-[50px] font-medium text-white mb-4 leading-tight">
            Is your Team AI ready?
          </h1>
          <p className="text-base md:text-[20px] font-[400] text-white/60 mb-8 leading-relaxed">
            Hands-on AI training customised to every role, stack, and KPI on
            your team. Same team, doing the work of five; Faster, Better, in a
            fraction of the time.
          </p>

          <div className="flex justify-center">
            <button
              onClick={() => {
                document
                  .getElementById("business-contact")
                  ?.scrollIntoView({ behavior: "smooth", block: "start" });
              }}
              className="border border-[#62626266]/40 bg-[#B8EF43] hover:bg-lime-300 text-black font-normal px-5 py-[10px] w-[251px] rounded-[4px] transition-all duration-300 ease-in-out shadow-lg hover:shadow-[0_8px_16px_-4px_rgba(184,239,67,0.4),_8px_8px_16px_-4px_rgba(184,239,67,0.4),_-8px_8px_16px_-4px_rgba(184,239,67,0.4)] text-sm md:text-base"
            >
              Get Started
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default B2BHero;
